import React, { useEffect, useState } from "react";
import { Col, Container, Form, Row, Button } from "react-bootstrap";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import { Get, Post } from "../Axios/AxiosFunctions";
import BodyLoader from "../Components/BodyLoader";
import { apiHeader, imageUrl, URL, validateEmail } from "../Config/apiUrl";
import Img from "../assets/images/allJobs_banner.png";
import ContractCard from "../Components/ContractCard";
import ViewContractModal from "../Components/ViewContractModal";
import { useSelector } from "react-redux";
import NoMoreJobs from "../Components/NoMoreJobs";

const CompanyContracts = () => {
  const history = useHistory();
  const [pageData, setPageData] = useState(null);
  const [isApiCall, setIsApiCall] = useState(true);
  const [contractsData, setContractsData] = useState([]);
  const [status, setStatus] = useState("offered");
  const accessToken = useSelector((state) => state.authReducer.access_token);
  const [openContractModal, setOpenContractModal] = useState(false);
  const [contractData, setContractData] = useState();
  const data = null;

  // getdata
  const getdata = async () => {
    const url = URL(`job/company-offered-jobs?status=${status}`);
    setIsApiCall(true);
    const response = await Get(url, accessToken);
    if (response !== undefined) {
      console.log("api", response?.data?.data);
      setContractsData(response?.data?.data);
    }

    setIsApiCall(false);
  };

  useEffect(() => {
    getdata();
  }, [status]);

  if (isApiCall) {
    return <BodyLoader />;
  }

  return (
    <div
      style={{
        backgroundColor: "#F8F8F8;",
      }}
    >
      <Container className="my-contracts-container company_contracts">
        <Row>
          {/* Header */}
          <Row>
            <Col md={6}>
              <div className="route">
                Home / <b>My Contracts</b>
              </div>
            </Col>
            <Col md={6} className="on-most-right">
              <select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                className="select-status route"
              >
                <option value="offered">Offered</option>
                <option value="completed">Completed</option>
              </select>
            </Col>
          </Row>
          {contractsData?.map((item, i) => {
            return (
              <Col key={i} xl={3} md={6} lg={4} sm={6} xs={12}>
                <ContractCard
                  data={item}
                  onClick={() => {
                    setContractData(item);
                    setOpenContractModal(true);
                  }}
                  isCompany={true}
                />
              </Col>
            );
          })}

          {contractsData?.length === 0 && (
            <NoMoreJobs text={"No Contracts found."} />
          )}
        </Row>
      </Container>
      {openContractModal && (
        <ViewContractModal
          open={openContractModal}
          setOpen={setOpenContractModal}
          setContractsData={setContractsData}
          contractData={contractData}
          isCompany={true}
        />
      )}
    </div>
  );
};

export default CompanyContracts;
